import { StrictMode } from "react";
import { mount } from "@/lib/mount";
import "@/index.css";
import { ArticlesPage } from "./ArticlesPage";

mount(
  <StrictMode>
    <ArticlesPage />
  </StrictMode>
);
